export const trustedByLogosTokens = {
  colors: {
    background: "#020202",
    text: "rgba(255, 255, 255, 0.58)",
    divider: "rgba(255, 255, 255, 0.14)",
  },
  maxWidth: {
    md: "960px",
    lg: "1180px",
    xl: "1440px",
    full: "100%",
  },
  spacing: {
    shellX: 20,
    railY: 22,
    labelGap: 34,
    logoColumnGap: 28,
    logoRowGap: 20,
    mobileRailY: 34,
    mobileLogoColumnGap: 28,
    mobileLogoRowGap: 28,
  },
  sizes: {
    labelWidth: 96,
    logoMinWidth: 118,
    logoMaxWidth: 160,
    logoMaxHeight: 44,
    mobileLogoMaxHeight: 56,
  },
  typography: {
    fontFamily:
      'Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    label: {
      fontSize: 11,
      lineHeight: 1.2,
      fontWeight: 800,
      letterSpacing: 0,
      textTransform: "uppercase" as const,
    },
  },
  image: {
    filter: "none",
    opacity: 0.9,
  },
} as const;

export type TrustedByLogosMaxWidthToken = keyof typeof trustedByLogosTokens.maxWidth;
